import { render, staticRenderFns } from "./CsrContent1.vue?vue&type=template&id=4c3bb811&scoped=true"
import script from "./CsrContent1.vue?vue&type=script&lang=js"
export * from "./CsrContent1.vue?vue&type=script&lang=js"
import style0 from "./CsrContent1.vue?vue&type=style&index=0&id=4c3bb811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3bb811",
  null
  
)

export default component.exports